import createStore from "astrid-helpers/src/createStore";
import { setScrollOffset } from "./scrollOffset";
import { getSearchResults } from "./searchResults";
export const [getSearchIndex, setSearchIndex, useSearchIndex, onSearchIndex] = createStore();
onSearchIndex(index => {
  const result = getSearchResults()[index];
  if (result) {
    setScrollOffset([result.page - 1 + result.rects.reduce((sum, {
      top
    }) => sum + top, 0) / result.rects.length, true]);
  }
});
//# sourceMappingURL=searchIndex.js.map